import IconTimes from './icons/IconTimes'

const Modal = ({ handleClose, children, className, sectionClassName }) => {
    return (
      <div className={`fxs_modal ${className || ''}`}>
        <section className={sectionClassName}>
          <p>
            {children}
            <button type="button" onClick={handleClose} class="fxs_btn fxs_btn_xsmall fxs_close"><IconTimes/></button>
          </p>
        </section>
      </div>
    )
  }

  export default Modal
